import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'trim'})
export class TrimPipe implements PipeTransform {
  transform(str: string, length: number = 30): string {
    if (str) {
      return str.length > 10 ? str.substring(0, length) : str
    }
    return ''
  }
}
